export { default } from './PaidFeatureBadge';
export { default as usePaidFeatureBadgeTier } from './usePaidFeatureBadgeTier';
